var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle, css, ThemeProvider } from 'styled-components';
import GoogleFontLoader from 'react-google-font-loader';
import { IntlProvider } from '@progress/kendo-react-intl';
import LBMaterial from '../Themes/LBMaterial';
var BaseStyles = createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n"])), props => css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        html, body {\n            font-family: ", ";\n            font-size: ", ";\n            margin: 0;\n        }\n\n        a {\n            color: ", ";\n            position: relative;\n            text-decoration: none;\n\n            &::after {\n                content: '';\n                position: absolute;\n                width: 100%;\n                transform: scaleX(0);\n                height: 1px;\n                bottom: 0;\n                left: 0;\n                background-color: ", ";\n                transform-origin: bottom right;\n                transition: transform 0.25s ease-out;\n            }\n\n            &:hover {\n                color: ", ";\n\n                &::after {\n                    transform: scaleX(1);\n                    transform-origin: bottom left;\n                }\n            }\n        }\n\n        h1,\n        h2,\n        h3,\n        h4,\n        h5,\n        h6 {\n            letter-spacing: 2px;\n            margin: 1rem 0;\n        }\n\n        p {\n            margin: 1rem 0;\n        }\n    "])), props.theme.typography.fontFamily, props.theme.typography.fontSize, props.theme.typography.link, props.theme.typography.linkHover, props.theme.typography.linkHover));

/**
 * The GlobalStyles components applies global styling to a few basic HTML elments.
 * The component also applies the LightBox Material theme, loads all variants of the
 * Google Roboto font and loads the internationalization provider service.
 */
var GlobalStyles = props => {
  var {
    children,
    locale
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GoogleFontLoader, {
    fonts: [{
      font: 'Roboto',
      weights: [100, '100i', 300, '300i', 400, '400i', 500, '500i', 700, '700i', 900, '900i']
    }]
  }), /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: LBMaterial
  }, /*#__PURE__*/React.createElement(BaseStyles, null), /*#__PURE__*/React.createElement(IntlProvider, {
    locale: locale
  }, children)));
};
GlobalStyles.defaultProps = {
  children: undefined,
  locale: 'en-US'
};
GlobalStyles.propTypes = {
  /**
   * Sets the children elements.
   */
  children: PropTypes.node,
  /**
   * The language used for the internationalization provider service.
   */
  locale: PropTypes.string
};
export default GlobalStyles;